module.exports = __webpack_public_path__ + "img/chineselogo.5053658a.png";